import React from 'react';
import I18n from 'i18n-js';
import { LockKeyIcon } from '@phosphor-icons/react';
import { RCThemedBox, RCFlex, RCIcon, RCText } from '@reverbdotcom/cadence/components';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { Paths } from '../shared/url_helpers';

const PaypalShopLockedModeBanner = () => {
  return (
    <RCThemedBox themeType="utility" variant="urgent-ultralight">
      <div className="site-wrapper ptb-4">
        <RCFlex gap="4" align={{ desktop: 'center', mobile: 'start' }}>
          <RCIcon size={8} icon={<LockKeyIcon />} color="accent-themed" />
          <RCFlex direction="col" gap="half">
            <RCText.Utility weight="bold" size="450">
              {I18n.t('discovery.sellerDashboard.paypalLockedModeBanner.title')}
            </RCText.Utility>
            <RCText>
              <Translate
                tag="p"
                text="discovery.sellerDashboard.paypalLockedModeBanner.description"
                className="mb-0"
              >
                <CoreLink
                  target="_blank"
                  to={Paths.shopPoliciesEdit.expand({})}
                  className="text-link weight-bold"
                >
                  <Translate text="discovery.sellerDashboard.paypalLockedModeBanner.linkText" />
                </CoreLink>
              </Translate>
            </RCText>
          </RCFlex>
        </RCFlex>
      </div>
    </RCThemedBox>
  );
};

export default PaypalShopLockedModeBanner;
